import { BrandStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

interface Props extends WidgetProps {}

export interface BrandDetailsShopAllStyles {
    container?: GridContainerProps;
    linksItem?: GridItemProps;
    productLink?: LinkPresentationProps;
}

export const shopAllStyles: BrandDetailsShopAllStyles = {
    container: {
        gap: 5,
        css: css`
            margin: 15px;
        `,
    },
    linksItem: {
        width: 12,
        css: css`
            justify-content: center;
            padding: 30px 0 0;
        `,
    },
    productLink: {
        css: css`
            background: #005cb9;
            text-transform: uppercase;
            font-weight: bold;
            font-size: 18px;
            padding-top: 0.6rem;
            padding-right: 1rem;
            padding-bottom: 0.65rem;
            padding-left: 1rem;
            text-decoration: none;
            span[class^="TypographyStyle"] {
                color: #fff;
            }
            :hover {
                background: #ab161a;
                span[class^="TypographyStyle"] {
                    color: #fff;
                    text-decoration: none;
                }
            }
        `,
    },
};

const styles = shopAllStyles;

const BrandDetailsImage: FC<Props> = () => {
    const { value: brand } = useContext(BrandStateContext);
    if (!brand) {
        return null;
    }

    return (
        <GridContainer data-test-selector="brandShopAll" {...styles.container}>
            <GridItem {...styles.linksItem}>
                <Link
                    data-test-selector="brandToProductPageLink"
                    href={brand.productListPagePath}
                    {...styles.productLink}
                >
                    {translate("SHOP ALL PRODUCTS")}
                </Link>
            </GridItem>
        </GridContainer>
    );
};

interface BrandDetailsLinkProps {
    path?: string;
    gridItemStyles?: GridItemProps;
    linkStyles?: LinkPresentationProps;
    children?: React.ReactNode;
}

const BrandLink: FC<BrandDetailsLinkProps> = ({ path, gridItemStyles, linkStyles, children }) => {
    if (!path) {
        return null;
    }
    return (
        <GridItem {...gridItemStyles}>
            <Link data-test-selector="brandToProductPageLink" href={path} {...linkStyles}>
                {children}
            </Link>
        </GridItem>
    );
};

const widgetModule: WidgetModule = {
    component: BrandDetailsImage,
    definition: {
        group: "Brand Details",
        icon: "image",
        displayName: "Brand Shop All Products Button",
        allowedContexts: ["BrandDetailsPage"],
    },
};

export default widgetModule;
